// frontend/src/api/delivery.js
import { apiClient } from './index';

const deliveryApi = {
  /**
   * Assign a driver or logistics partner to an order (Admin)
   */
  assignDelivery: async (data) => {
    return await apiClient.post('/delivery/assign', data);
  },

  /**
   * Get all delivery assignments (Admin)
   */
  getAllDeliveries: async (status = null) => {
    const url = status ? `/delivery/?status=${status}` : '/delivery/';
    return await apiClient.get(url);
  },

  /**
   * Update the status of a delivery (Admin & Partner)
   * @param {string} assignmentId 
   * @param {string} status - 'picked_up', 'in_transit', 'delivered', 'failed'
   * @param {string} notes - Optional
   * @param {string} proofUrl - Optional URL for Proof of Delivery image
   */
  updateDeliveryStatus: async (assignmentId, status, notes = null, proofUrl = null) => {
    return await apiClient.put(`/delivery/${assignmentId}/status`, { 
        status, 
        notes,
        proof_of_delivery_url: proofUrl 
    });
  },

  /**
   * Get jobs assigned to the logged-in partner (Partner)
   */
  getMyJobs: async () => {
      return await apiClient.get('/delivery/partner/my-jobs');
  }
};

export { deliveryApi };